<template>
    <div class="main">
        <!-- 头部导航栏 -->
        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect"
            background-color="rgb(250, 250, 250)">
            <el-menu-item index="1">BSR对比</el-menu-item>
        </el-menu>

        <!-- 主要功能区域 -->
        <div class="bsrmanage">
            <!-- 第一个选择器: 选择分组或者ASIN -->
            <div class="fistselect">
                <el-select v-model="firstSelectValue" placeholder="请选择" @change="handleFirstSelectChange">
                    <el-option v-for="item in firstSelectOptions" :key="item.value" :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <!-- 第二个选择器: 根据第一个选择筛选对应信息 -->
            <div class="secoundselect">
                <div v-if="!firstSelectValue" class="default-prompt">
                    <span>请选择查看方式</span>
                </div>
                <!-- 当选择分组时 - 普通多选下拉框 -->
                <!-- <el-select v-if="firstSelectValue === 'group'" v-model="secondSelectValue" placeholder=""
                    :disabled="!firstSelectValue" multiple collapse-tags @change="handleSelectionChange">
                    <el-option v-for="item in secondSelectOptions" :key="item.value" :label="item.label"
                        :value="item.value" />
                </el-select> -->

                <!-- 当选择group时 - 可搜索的多选下拉框 改成了可以进行模糊搜索下拉框     -->
                <el-select v-else-if="firstSelectValue === 'group'" v-model="secondSelectValue"
                    placeholder="请输入组名搜索或下拉搜索" multiple filterable remote reserve-keyword
                    :remote-method="remoteSearchAsin" :loading="searchLoading" collapse-tags
                    @change="handleSelectionChange">
                    <el-option v-for="item in secondSelectOptions" :key="item.value" :label="item.label"
                        :value="item.value">
                        <div class="select-option-content">
                            <span class="option-main-text">{{ item.label }}</span>
                            <span class="option-country-tag" v-if="item.country">{{ item.country }}</span>
                        </div>
                    </el-option>
                </el-select>

                <!-- 当选择ASIN时 - 可搜索的多选下拉框 -->
                <el-select v-else-if="firstSelectValue === 'asin'" v-model="secondSelectValue"
                    placeholder="请输入ASIN或品名搜索" multiple filterable remote reserve-keyword
                    :remote-method="remoteSearchAsin" :loading="searchLoading" collapse-tags
                    @change="handleSelectionChange">
                    <el-option v-for="item in filteredAsinOptions" :key="item.value" :label="item.label"
                        :value="item.value">
                        <div class="select-option-content">
                            <span class="option-main-text">{{ item.label }}</span>
                            <span class="option-country-tag" v-if="item.country">{{ item.country }}</span>
                        </div>
                    </el-option>
                </el-select>

            </div>
            <!-- 清除按钮 -->
            <div class="cleanall">
                <el-button @click="clearAll">清除</el-button>
            </div>

            <div style="display: flex;width: 7.5%;">
                <!-- <el-button type="primary" size="large" @click.stop="generateCharts"
                    :disabled="generateList.length === 0">
                    生成图表
                </el-button> -->
                <el-button type="primary" size="large" @click.stop="downloadChartData">
                    下载数据
                </el-button>
            </div>

            <!-- 编辑按钮 -->
            <div class="editbutton">
                <el-button type="primary" @click="showEditDialog">ASIN & 组 管理</el-button>
            </div>

            <!-- 搜索框 -->
            <div class="search-container">
                <!-- 搜索输入框（带防抖） -->
                <div class="searchbox">
                    <el-input v-model="searchText" placeholder="请输入搜索内容(仅支持单ASIN查找)" clearable
                        @input="handleSearchInput">
                        <el-button slot="append" icon="el-icon-search" @click="executeSearch" />
                    </el-input>
                </div>
                <div class="search-results-container" v-show="showResults" @mouseenter="keepResultsVisible"
                    @mouseleave="hideResults">
                    <!-- 结果列表 -->
                    <div v-if="searchResults.length > 0" class="search-results">
                        <el-table :data="searchResults" highlight-current-row @row-click="handleResultClick">
                            <!-- 搜索结果列表 -->
                            <el-table-column prop="ASIN" label="匹配ASIN" />
                            <el-table-column prop="pm" label="匹配品名" />
                            <!-- 可根据实际数据添加更多列 -->
                        </el-table>
                    </div>
                    <!-- 无结果提示 -->
                    <div v-else class="no-results">
                        未找到匹配项
                    </div>
                </div>
            </div>
        </div>
        <!-- 图表展示区域 -->
        <div class="datebox">
            <!-- 图表展示区域 -->
            <div class="chart-container">
                <!-- 情况1：显示图表容器（当有数据时） -->
                <div v-if="hasChartData" ref="chartDom" style="width: 100%; height: 100%;"></div>
                <!-- 情况2：显示占位符（当无数据时） -->
                <div v-else class="chart-placeholder">
                    BSR数据图表将在这里展示
                </div>
            </div>

            <!-- 数据列表区域 -->
            <div class="datalist">
                <div class="datahead">
                    <p>选择天数</p>
                </div>
                <div class="databutton" style="display: flex; flex-direction: column; gap: 10px;">
                    <div style="display: flex; gap: 10px;">
                        <el-button v-for="days in [30, 60, 90]" :key="days" @click="selectDays(days)"
                            :type="selectedDays === days ? 'primary' : ''">
                            {{ days }}天
                        </el-button>
                    </div>
                    <!-- 日期范围选择器 -->
                    <el-date-picker v-model="dateRange" type="daterange" range-separator="至" start-placeholder="开始日期"
                        end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="handleDateRangeChange"
                        style="width: 100%;"></el-date-picker>
                    <!-- 输入天数选择器 -->
                    <!-- <el-input v-model="customDays" placeholder="自定义天数" @keyup.enter.native="selectCustomDays">
                        <el-button slot="append" icon="el-icon-check" @click="selectCustomDays" />
                    </el-input> -->
                </div>
                <div class="legend-header">
                    <span>ASIN控制</span>
                    <span class="count">({{ legendItems.length }})</span>
                </div>
                <div class="legend-scroll-container">
                    <div v-for="(item, index) in legendItems" :key="item.name" class="legend-item draggable-item"
                        draggable="true" @dragstart="handleDragStart($event, item)" @click="handleLegendClick(index)">
                        <el-checkbox v-model="item.visible" @click.stop.native />
                        <div class="color-block" :style="{ backgroundColor: item.color }" />
                        <span class="legend-name">{{ item.name }}</span>
                        <i class="el-icon-rank drag-handle"></i>
                    </div>
                    <div v-if="legendItems.length === 0" class="empty-tip">
                        暂无ASIN数据
                    </div>
                </div>


                <!-- <div class="databody">
                    <div class="datahead">数据显示</div>
                    <div class="data-container">
                        每个ASIN的数据显示在一个独立的盒子中
                        <div v-for="item in filteredData" :key="item.asin" class="data-box">
                            <div class="data-box-header">
                                <span class="asin">{{ item.asin }}</span>
                                
                            </div>
                            <div class="data-box-content">
                                <div class="data-field">
                                    <span class="field-label">创建者：</span>
                                    <span class="field-value">{{ item.earliest_create_person }}</span>
                                </div>
                                <div class="data-field">
                                    <span class="field-label">创建时间：</span>
                                    <span class="field-value">{{ formatDateTime(item.earliest_create_time) }}</span>
                                </div>
                                <div class="data-field">
                                    <span class="field-label">更新者：</span>
                                    <span class="field-value">{{ item.latest_update_person }}</span>
                                </div>
                                <div class="data-field">
                                    <span class="field-label">更新时间：</span>
                                    <span class="field-value">{{ formatDateTime(item.latest_update_time) }}</span>
                                </div>
                                销售排名数据展示
                                <div class="rankings-container">
                                    <div class="rankings-header">销售排名趋势</div>
                                    <div class="rankings-days">最近 {{ selectedDays }} 天数据</div>
                                    <div class="rankings-values">
                                        <span v-for="(rank, index) in item.filteredRanks" :key="index"
                                            class="rank-value">
                                            {{ rank }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>

        <!-- 编辑对话框 -->
        <el-dialog :title="editDialogTitle" :visible.sync="editDialogVisible" width="70%">
            <el-tabs v-model="activeEditTab">
                <!-- ASIN管理 -->
                <el-tab-pane label="ASIN管理" name="asin">
                    <div class="management-container">
                        <!-- 左侧：添加ASIN -->
                        <div class="add-section">
                            <h3>添加ASIN</h3>
                            <el-form :model="newAsinForm" label-width="100px">
                                <el-form-item label="ASIN">
                                    <el-input v-model="newAsinForm.asin" placeholder="请输入ASIN"></el-input>
                                </el-form-item>
                                <el-form-item label="产品名称">
                                    <el-input v-model="newAsinForm.productName" placeholder="请输入产品名称"></el-input>
                                </el-form-item>
                                <el-form-item label="国家">
                                    <el-input v-model="newAsinForm.country" placeholder="请输入国家"></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary" @click="addAsin">确认添加</el-button>
                                </el-form-item>
                            </el-form>
                        </div>

                        <!-- 右侧：ASIN列表 -->
                        <div class="list-section">
                            <h3>ASIN列表</h3>
                            <div class="search-box">
                                <el-input v-model="asinSearchQuery" placeholder="输入ASIN或产品名称搜索" clearable
                                    @keyup.enter.native="searchAsin" @clear="searchAsin">
                                    <el-button slot="append" icon="el-icon-search" @click="searchAsin"></el-button>
                                </el-input>
                            </div>
                            <el-table :data="filteredAsinList" border style="width: 100%" height="420px"
                                highlight-current-row>
                                <!-- ASIN列（可切换编辑状态） -->
                                <el-table-column prop="asin" label="ASIN" width="150">
                                    <template v-slot="scope">
                                        <el-input v-if="scope.row.isEditing" v-model="scope.row.editAsin" size="mini"
                                            @keyup.enter.native="confirmEdit(scope.row)" />
                                        <span v-else>{{ scope.row.asin }}</span>
                                    </template>
                                </el-table-column>

                                <!-- 产品名称列（可切换编辑状态） -->
                                <el-table-column prop="pm" label="产品名称">
                                    <template v-slot="scope">
                                        <el-input v-if="scope.row.isEditing" v-model="scope.row.editPm" size="mini" />
                                        <span v-else>{{ scope.row.pm }}</span>
                                    </template>
                                </el-table-column>

                                <!-- 国家列 -->
                                <el-table-column prop="country" label="国家" width="80px">
                                    <template v-slot="scope">
                                        <el-input v-if="scope.row.isEditing" v-model="scope.row.editCountry" />
                                        <span v-else>{{ scope.row.country }}</span>
                                    </template>
                                </el-table-column>

                                <!-- 操作列（按钮始终同行显示） -->
                                <el-table-column label="操作" width="400">
                                    <template v-slot="scope">
                                        <div style="display: flex; gap: 8px;">
                                            <!-- 动态切换修改/确认按钮 -->
                                            <el-button size="mini" :type="scope.row.isEditing ? 'success' : 'primary'"
                                                @click="scope.row.isEditing ? confirmEdit(scope.row) : startEdit(scope.row)"
                                                :loading="scope.row.isSaving">
                                                {{ scope.row.isEditing ? '确认' : '修改' }}
                                            </el-button>
                                            <!-- 取消按钮（仅编辑时显示） -->
                                            <el-button v-if="scope.row.isEditing" size="mini"
                                                @click="cancelEdit(scope.row)">
                                                取消
                                            </el-button>
                                            <!-- 上传BSR文件按钮 -->
                                            <el-button type="button" @click="showturnbsrpage(scope.row.fullname)"
                                                :disabled="scope.row.isEditing">上传BSR
                                            </el-button>
                                            <!-- 删除按钮 -->
                                            <el-button size="mini" type="danger" @click="handleDeleteAsin(scope.row)"
                                                :disabled="scope.row.isEditing">
                                                删除
                                            </el-button>
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </el-tab-pane>
                <!-- 组管理 -->
                <el-tab-pane label="组管理" name="group">
                    <div class="management-container">
                        <!-- 左侧：添加组 -->
                        <div class="add-section">
                            <h3>创建组</h3>
                            <el-form label-width="100px" style="width: 400px; margin-top: 30%;">
                                <el-form-item label="组名称">
                                    <el-input v-model="newgroupname" placeholder="格式：组名-国家（如：分组1-US）"></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary" @click="addGroup">确认添加</el-button>
                                </el-form-item>
                            </el-form>
                            <!-- <h3>添加至组</h3>
                            <el-form :model="newGroupForm" label-width="100px" style="width: 300px;">
                                <el-select v-model="newGroupForm.name" placeholder="请选择组">
                                    <el-option v-for="group in editgroupList" :key="group.id" :label="group.分组"
                                        :value="group.分组"></el-option>
                                </el-select>
                                <el-select v-model="newGroupForm.subasinlist" multiple collapse-tags
                                    placeholder="请选择asin+品名" @change="handleAsinSelect" :popper-append-to-body="false"
                                    style="margin-top: 10%;">
                                    <div>
                                        带复选框的选项
                                        <el-option v-for="item in asinDetail" :key="item.fullname"
                                            :label="item.fullname" :value="item.fullname">
                                            <div
                                                style="display: flex; justify-content: space-between; align-items: center;">
                                                <span>{{ item.fullname }}</span>
                                            </div>
                                        </el-option>
                                    </div>
                                </el-select>
                                <el-form-item>
                                    <el-button style="margin-top: 10%;" type="primary"
                                        @click="GAlistsubmit">确认创建</el-button>
                                </el-form-item>
                            </el-form> -->
                        </div>
                        <!-- 右侧：组列表 -->
                        <div class="list-section">
                            <h3>组列表</h3>
                            <div class="search-box">
                                <el-input v-model="groupSearchQuery" placeholder="输入组名搜索" clearable
                                    @keyup.enter.native="searchGroup" @clear="searchGroup">
                                    <el-button slot="append" icon="el-icon-search" @click="searchGroup"></el-button>
                                </el-input>
                            </div>
                            <el-table :data="filteredGroupList" border style="width: 100%" height="420px"
                                highlight-current-row>
                                <!-- ID列 -->
                                <el-table-column prop="id" label="ID" width="80"></el-table-column>
                                <!-- 组名列 -->
                                <el-table-column prop="分组" label="组名称" width="200">
                                    <template slot-scope="scope">
                                        <el-input v-if="scope.row.isEditing" v-model="scope.row.editName" size="mini"
                                            @keyup.enter.native="confirmEdit(scope.row)" />
                                        <span v-else>{{ scope.row.分组 }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="create_person" label="创建者" width="150"></el-table-column>
                                <el-table-column prop="country" label="国家" width="80"></el-table-column>
                                <!-- ASIN列表列 -->
                                <!-- <el-table-column label="ASIN列表" width="300">
                                    <template v-slot="scope">
                                        <el-select placeholder="点击查看组内ASIN" size="mini" style="width: 100%">
                                            <el-option v-for="(item, index) in scope.row.asin_list" :key="index"
                                                :label="`${item.asin} (${item.pm})`" :value="item.asin">
                                                <span>{{ item.asin }}</span>
                                                <span style="float: right; color: #8492a6; font-size: 12px">{{ item.pm
                                                    }}</span>
                                            </el-option>
                                        </el-select>
                                        <div style="font-size: 12px; color: #909399; margin-top: 5px">
                                            共 {{ scope.row.asin_list.length }} 个ASIN
                                        </div>
                                    </template>
                                </el-table-column> -->
                                <!-- 操作列 -->
                                <el-table-column label="操作" width="300">
                                    <template v-slot="scope">
                                        <div style="display: flex; gap: 8px;">
                                            <!-- 修改组名按钮 -->
                                            <el-button size="mini" :type="scope.row.isEditing ? 'success' : 'primary'"
                                                @click="scope.row.isEditing ? confirmGroupEdit(scope.row) : startGroupEdit(scope.row)"
                                                :loading="scope.row.isSaving">
                                                {{ scope.row.isEditing ? '确认修改' : '修改组名' }}
                                            </el-button>
                                            <!-- 管理ASIN按钮 -->
                                            <el-button size="mini" type="warning" @click="manageAsins(scope.row)"
                                                :disabled="scope.row.isEditing">
                                                管理ASIN
                                            </el-button>
                                            <!-- 删除组按钮 -->
                                            <el-button size="mini" type="danger" @click="handleDeleteGroup(scope.row)"
                                                :disabled="scope.row.isEditing">
                                                删除组
                                            </el-button>
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </el-tab-pane>

            </el-tabs>
        </el-dialog>

        <!-- bsr文件上传对话框 -->
        <el-dialog :title="showbsrpagetitle" :visible.sync="showbsrpage" width="50%" :close-on-click-modal="false">
            <div class="bsr-task-manager">
                <!-- 添加任务按钮 -->
                <!-- <div class="task-header">
                    <el-button type="primary" icon="el-icon-plus" style="width: 20%;" @click="addTask">
                        添加任务
                    </el-button>
                    <span class="task-count">当前任务数: {{ tasks.length }}</span>
                </div> -->
                <bsr-task-manager :current-fullname="currentFullname" />
                <!-- 任务列表 -->
                <div class="task-list">
                    <el-card v-for="(task, index) in tasks" :key="task.id" class="task-item">
                        <div class="task-title">
                            <span>任务</span>
                            <!-- <el-button type="danger" icon="el-icon-delete" size="mini" style="width: 8%;"
                                @click="removeTask(index)"></el-button> -->
                        </div>

                        <!-- 任务内容 -->
                        <el-form label-width="100px">
                            <!-- ASIN选择 -->
                            <el-form-item label="确认ASIN">
                                <!-- <el-select v-model="task.asin" placeholder="请选择ASIN" clearable
                                    @change="handleAsinChange(task)" style="width: 100%;">
                                    <el-option v-for="item in asinDetail" :key="item.asin"
                                        :label="`${item.pm} (${item.asin})`" :value="item.asin" />
                                </el-select> -->
                                <h3>{{ currentFullname }}</h3>
                            </el-form-item>

                            <!-- 文件格式选择 -->
                            <el-form-item label="文件格式">
                                <el-radio-group v-model="task.fileFormat" @change="resetFileInfo">
                                    <el-radio-button label="old">旧数据表格</el-radio-button>
                                    <el-radio-button label="new">新数据表格</el-radio-button>
                                </el-radio-group>
                            </el-form-item>

                            <!-- 文件上传 -->
                            <el-form-item label="上传文件">
                                <div class="file-uploader">
                                    <el-upload action="#" :on-change="file => handleFileChange(file, task)"
                                        :auto-upload="false" accept=".csv" :show-file-list="false">
                                        <el-button type="primary" icon="el-icon-upload">
                                            选择文件
                                        </el-button>
                                    </el-upload>

                                    <div class="file-display" v-if="task.file">
                                        <p>原文件名: {{ task.file.name }}</p>
                                        <p>已修改文件名: {{ task.fileName }} </p>
                                    </div>
                                    <div v-else class="no-file">
                                        <i class="el-icon-upload"></i>
                                        <span>请先选择文件格式后上传</span>
                                    </div>
                                </div>
                            </el-form-item>
                        </el-form>
                    </el-card>
                </div>

                <!-- 提交按钮 -->
                <div class="task-footer">
                    <el-button type="success" :loading="isSubmitting" @click="submitAllTasks">
                        上传
                    </el-button>
                </div>
            </div>
        </el-dialog>

        <!-- bsr组内asin管理 -->
        <!-- 管理ASIN对话框 -->
        <el-dialog :title="`管理分组: ${currentGroup}`" :visible.sync="manageAsinDialogVisible" width="50%" top="5vh"
            @close="manageAsinDialogVisible = false">
            <div class="manage-asin-container">
                <!-- 添加ASIN表单 - 横向排列 7:3 -->
                <div class="add-asin-form-inline">
                    <div class="asin-select-wrapper">
                        <el-select v-model="groupAsinForm.asin" filterable remote reserve-keyword
                            placeholder="请输入ASIN搜索" :loading="searchLoading" style="width: 100%;">
                            <el-option v-for="item in asinDetail" :key="item.asin" :label="`${item.fullname}`"
                                :value="item.id" />
                        </el-select>
                    </div>
                    <el-button type="primary" @click="addAsinToGroup" :disabled="!groupAsinForm.asin">
                        添加ASIN
                    </el-button>
                </div>

                <!-- ASIN列表 - 拖拽排序 -->
                <div class="asin-sort-container">
                    <div class="sort-header">
                        <span>ASIN列表（拖拽调整顺序）</span>
                        <span class="asin-count">共 {{ groupAsins.length }} 个ASIN</span>
                    </div>
                    <draggable v-model="groupAsins" :options="{ animation: 200, handle: '.drag-handle' }"
                        @end="onDragEnd" class="asin-drag-list">
                        <div v-for="(item, index) in groupAsins" :key="item.id" class="asin-drag-item">
                            <div class="drag-handle">
                                <i class="el-icon-rank"></i>
                            </div>
                            <div class="asin-info">
                                <div class="asin-position">
                                    <el-tag :type="item.is_sorted ? 'success' : 'info'" size="mini">
                                        {{ item.is_sorted ? '第' + item.position + '位' : '待排序' }}
                                    </el-tag>
                                </div>
                                <div class="asin-details">
                                    <span class="asin-text">{{ item.asin }}</span>
                                    <span class="pm-text">{{ item.pm }}</span>
                                    <el-tag size="mini">{{ item.country }}</el-tag>
                                </div>
                            </div>
                            <div class="asin-actions">
                                <el-button type="danger" size="mini" icon="el-icon-delete"
                                    @click="removeAsinFromGroup(item.asin)" circle title="删除">
                                </el-button>
                            </div>
                        </div>
                    </draggable>
                    <div v-if="groupAsins.length === 0" class="empty-tip">
                        暂无ASIN数据，请添加
                    </div>
                </div>
            </div>

            <div slot="footer" class="dialog-footer dialog-footer-compact">
                <el-button type="primary" @click="saveAsinOrder" :loading="isSavingOrder" size="small">
                    保存排序
                </el-button>
                <el-button @click="manageAsinDialogVisible = false" size="small">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { debounce } from 'lodash';
import * as echarts from 'echarts';
import dayjs from 'dayjs';
import draggable from 'vuedraggable';
export default {
    components: {
        draggable
    },
    data() {
        return {
            activeIndex: '1',
            // 第一个选择器相关
            firstSelectValue: '',
            firstSelectOptions: [
                { value: 'group', label: '按分组查看' },
                { value: 'asin', label: '按ASIN查看' }
            ],

            // 第二个选择器相关
            allitem: [],
            secondSelectValue: '',
            secondSelectOptions: [],
            generateList: [], // 存储待生成图表的选项
            searchLoading: false,             // 搜索加载状态
            searchQuery: '',                 // 搜索关键词
            filteredAsinOptions: [],

            // 搜索框
            searchText: '',
            searchResults: [],
            searchPerformed: false,
            isSearching: false,
            showResults: false,
            searchDebounceTimer: null,
            isMouseOverResults: false,

            // 编辑对话框相关
            editDialogVisible: false,
            editDialogTitle: '',
            activeEditTab: 'asin',
            //上周进度，到这里设置新组名
            newgroupname: '',
            newGroupForm: {
                name: '',
                subasinlist: []
            },
            submitasinlist: [],//需要提交的组内asin列
            editgroupList: [], //用作编辑框内的组获取
            manageAsinDialogVisible: false,
            currentGroup: null, // 当前管理的分组
            groupAsins: [],     // 直接从 scope.row.asin_list 获取
            isSavingOrder: false, // 保存排序中
            newAsinForm: {
                asin: '',
            },
            groupAsinForm: {  // 用于组管理中的ASIN添加
                asin: '',
                productName: ''
            },
            groupDetail: [],   //存储所有分组数据
            asinDetail: [],   //存储所有aisn数据
            asinSearchQuery: '',      // ASIN搜索关键词
            groupSearchQuery: '',     // 组搜索关键词
            filteredAsinList: [],     // 过滤后的ASIN列表
            filteredGroupList: [],    // 过滤后的组列表
            // 模拟数据(后续后端返回的数据也得是如此类型)
            groupList: [],
            asinList: [],


            //显示上传bsr窗口
            showbsrpage: false,
            showbsrpagetitle: '',
            //bsr任务列表
            isSubmitting: false,
            tasks: [], // 任务列表
            fileFormat: 'old',

            // 数据展示相关
            checkedDataItems: [],
            myChart: null,
            chartData: null, // 存储图表数据，null表示未加载
            hasChartData: false,
            selectedDays: 30, // 默认选择30天
            customDays: '',   // 自定义天数输入
            dateRange: [],    // 选择对应的日期。
            rawChartData: [], // 存储原始图表数据
            filteredData: [], // 存储过滤后的数据
            legendItems: [],         // 存储图例数据
            activeLegendIndex: -1,    // 当前选中的图例索引
            maxLegendItems: 20,
            availableAsins: [], // 可用ASIN列表(从rawChartData提取)
        }
    },
    created() {
        // 页面加载时初始化数据
        this.initData();
        this.selectedDays = 30;
        // this.generateCharts();
        // 创建防抖函数（500ms延迟）
        this.debouncedSearch = debounce(this.searchDatabase, 500);
    },
    mounted() {
        // this.initChart();
    },
    computed: {
        // 检查是否可以提交
        canSubmit() {
            return this.tasks.length > 0 &&
                this.tasks.every(t =>
                    t.asin &&
                    t.pm &&
                    t.file
                )
        }
    },

    props: {
        currentFullname: {
            type: String,
            default: ''
        }
    },
    beforeDestroy() {
        // 组件销毁时清理图表
        if (this.myChart) {
            this.myChart.dispose();
        }
    },
    methods: {
        // 初始化数据
        async initData() {
            try {
                // 并行请求分组和ASIN数据
                //groupRes对应第一个接口的参数
                const [asinRes, editgroup] = await Promise.all([
                    //this.$axios.get('/vue/bsr_d/bsr_d_all'),   //获取组详情数据
                    this.$axios.get('/vue/vue_bsr/asin_d_all'),  //获取所有的asin数据，不存在组别单asin
                    this.$axios.get("/vue/bsr_d/fenzhu_select")
                ]);
                // console.log('groupRes', groupRes)
                // this.groupDetail = groupRes.data.reverse().map(item => ({
                //     ...item,
                // }))
                console.log(this.groupDetail)
                console.log('asinRes', asinRes)
                this.asinDetail = asinRes.data.reverse().map(item => {
                    const [asin, pm] = item['asin_pm'].split('+');
                    return {
                        id: item.id,
                        asin,
                        pm,
                        country: item['country'],
                        fullname: item['asin_pm'] + `(${item['country']})`,
                        checked: false,
                        isEditing: false,
                        editAsin: asin,   // 添加编辑字段
                        editPm: pm,       // 添加编辑字段
                        editCountry: item['country'], // 添加编辑国家字段
                        isSaving: false
                    };
                });
                console.log(this.asinDetail)
                this.editgroupList = editgroup.data.reverse().map(item => ({
                    id: item.id,
                    分组: item.分组,
                    create_person: item.创建者,
                    country: item.country_code
                }))
                console.log(this.editgroupList)
            } catch (error) {
                console.error('初始化数据失败:', error);
                this.$message.error('加载数据失败');
            }
        },

        //日期处理方法
        formatDateTime(isoString) {
            return dayjs(isoString).format('YYYY-MM-DD HH:mm:ss');
        },

        handleSelect(key, keyPath) {
            console.log(key, keyPath);
        },

        async handleFirstSelectChange(value) {
            this.groupList = [];  // 新增
            this.asinList = [];    // 新增
            this.secondSelectValue = '';
            if (value === 'group') {
                const res = await this.$axios.get("/vue/bsr_d/fenzhu_select")
                if (res.msg === "success") {
                    console.log(res.data)
                    this.groupList = res.data
                    console.log(this.groupList)
                    this.secondSelectOptions = this.groupList.map(group => ({
                        value: `${group.分组}+${group.country_code}`,
                        label: `${group.分组}+${group.country_code}`,
                        country: group.country_code
                    }))
                } else {
                    this.$message.error(res.msg)
                }
            } else if (value === 'asin') {
                this.asinList = [];
                this.asinList = this.asinDetail
                this.secondSelectOptions = this.asinList.map(asin => ({
                    value: `${asin.asin}+${asin.pm}+${asin.country}`,
                    label: `${asin.asin}+${asin.pm}`,
                    country: asin.country
                }));
            }
        },

        remoteSearchAsin(query) {
            this.searchQuery = query;
            console.log("searchQuery", this.searchQuery)
            this.searchLoading = true;
            // 模拟异步搜索（实际项目中可能是API请求）
            setTimeout(() => {
                if (query) {
                    // 搜索逻辑：同时匹配ASIN和品名
                    this.filteredAsinOptions = this.secondSelectOptions.filter(item => {
                        const searchText = query.toLowerCase();
                        console.log("searchText", searchText)
                        return (
                            item.label.toLowerCase().includes(searchText) ||
                            item.value.toLowerCase().includes(searchText)
                        );
                    });
                    console.log("filteredAsinOptions", this.filteredAsinOptions)
                } else {
                    // 无搜索词时显示全部
                    this.filteredAsinOptions = [...this.secondSelectOptions];
                }
                this.searchLoading = false;
            }, 200);
        },

        //第二个选项框的处理方法
        // 初始化选项数据（在获取secondSelectOptions时）
        initOptions() {
            this.secondSelectOptions = this.secondSelectOptions.map(item => ({
                ...item,
                checked: false
            }));
        },

        // 复选框变化处理
        handleCheckChange(item, isChecked) {
            item.checked = isChecked;
            if (isChecked) {
                this.generateList.push(item);
            } else {
                this.generateList = this.generateList.filter(v => v !== item.value);
            }
        },

        // 多选变化处理
        handleSelectionChange(selected) {
            this.secondSelectOptions.forEach(item => {
                item.checked = selected.includes(item.value);
            });
            console.log("selected", selected)
            this.generateList = [...selected];
            console.log("this.generateList", this.generateList)
            this.generateCharts()
        },

        // 处理ASIN选择变化
        handleAsinSelect(selected) {
            // 更新选中状态
            this.asinDetail.forEach(item => {
                item.checked = selected.includes(item.value);
            });
        },
        // 处理复选框变化
        // handleAsinCheckChange(item, isChecked) {
        //     item.checked = isChecked;
        //     if (isChecked) {
        //         if (!this.subasinlist.includes(item.value)) {
        //             this.subasinlist.push(item.value);
        //         }
        //     } else {
        //         this.subasinlist = this.subasinlist.filter(v => v !== item.value);
        //     }
        // },

        async GAlistsubmit() {
            try {
                // 1. 验证表单数据
                if (!this.newGroupForm.name) {
                    this.$message.warning('请选择分组');
                    return;
                }

                if (this.newGroupForm.subasinlist.length === 0) {
                    this.$message.warning('请至少选择一个ASIN');
                    return;
                }

                // 2. 准备提交数据
                const submitData = {
                    groupname: this.newGroupForm.name,
                    asins: this.newGroupForm.subasinlist.map(asin => {
                        const item = this.asinDetail.find(i => i.value === asin);
                        return {
                            asin: asin.split('+')[0], // 假设格式是 "ASIN+品名"
                            pm: asin.split('+')[1] || '', // 提取品名
                        };
                    })
                };
                console.log(submitData)
                // 3. 调用后端API
                const response = await this.$axios.post('/vue/vue_bsr/add_asins_to_group', submitData);
                // 4. 处理响应
                if (response.code === 200) {
                    this.$message.success('添加ASIN到分组成功');
                    // 清空表单
                    this.submitasinlist = [];
                    this.asinDetail.forEach(item => {
                        item.checked = false;
                    });
                    // 刷新数据
                    this.initData();
                } else {
                    this.$message.error(response.message || '操作失败');
                }
            } catch (error) {
                console.error('提交失败:', error);
                this.$message.error('提交失败: ' + (error.response?.data?.message || error.message));
            }
        },

        // 生成图表
        async generateCharts(isSwitchingDays = false) {
            // 检查是否选择了数据
            if (!this.generateList || this.generateList.length === 0) {
                this.$message.warning('请先选择数据');
                return Promise.reject('请先选择数据');
            }

            // 构造请求参数
            let params = {
                operation: this.firstSelectValue,
            };

            // 如果是按ASIN查看，需要添加国家字段
            if (this.firstSelectValue === 'asin') {
                // 从secondSelectOptions中找到对应的国家信息
                const selectlistWithCountry = this.generateList.map(value => {
                    const option = this.secondSelectOptions.find(opt => opt.value === value);
                    if (option && option.country) {
                        return `${value}`;
                    }
                    return value;
                });
                params.selectlist = selectlistWithCountry.join(',');
            } else {
                // 分组模式，直接使用generateList
                params.selectlist = this.generateList.join(',');
            }

            if (this.dateRange && this.dateRange.length === 2) {
                params.startDate = this.dateRange[0];
                params.endDate = this.dateRange[1];
            } else if (this.selectedDays) {
                params.days = this.selectedDays;
            } else {
                params.days = 30;
            }

            this.isChartLoading = true;
            try {
                const res = await this.$axios.post('/vue/vue_bsr/buildchart', params);
                if (res.code === 200) {
                    // 只处理有效数据
                    this.rawChartData = res.data.filter(item => item.SalesRank_list && item.date_list);

                    // 默认/天数模式
                    if (!this.dateRange || this.dateRange.length !== 2) {
                        this.filteredData = this.rawChartData.map(item => {
                            const dates = item.date_list;
                            const ranks = item.SalesRank_list;
                            return {
                                asin: item.ASIN,
                                pm: item.pm,
                                country_code: item.country_code,
                                filteredDates: dates.slice(-this.selectedDays),
                                filteredRanks: ranks.slice(-this.selectedDays),
                                BSR_Child_Rank: item.BSR_Child_Rank_list ? item.BSR_Child_Rank_list.slice(-this.selectedDays) : [],
                                BSR_Child_Name: item.BSR_Child_Name,
                                hasChildData: item.has_child_data || false
                            };
                        });
                    } else {
                        // 日期范围模式
                        const [start, end] = this.dateRange;
                        this.filteredData = this.rawChartData.map(item => {
                            const dates = item.date_list;
                            const ranks = item.SalesRank_list;
                            const filtered = dates.map((date, idx) => ({
                                date,
                                rank: ranks[idx],
                                childRank: item.BSR_Child_Rank_list ? item.BSR_Child_Rank_list[idx] : null
                            })).filter(d => d.date >= start && d.date <= end);
                            return {
                                asin: item.ASIN,
                                pm: item.pm,
                                country_code: item.country_code,
                                filteredDates: filtered.map(d => d.date),
                                filteredRanks: filtered.map(d => d.rank),
                                BSR_Child_Rank: filtered.map(d => d.childRank),
                                BSR_Child_Name: item.BSR_Child_Name,
                                hasChildData: item.has_child_data || false
                            };
                        });
                    }

                    this.hasChartData = false; // 初始化为false，等待用户点击ASIN控制列

                    // 更新可用ASIN列表
                    this.availableAsins = this.filteredData.map(item => ({
                        asin: item.asin,
                        pm: item.pm,
                        country_code: item.country_code,
                        fullName: `${item.pm} (${item.asin})`,
                        BSR_Child_Name: item.BSR_Child_Name,
                        hasChildData: item.hasChildData
                    }));

                    // 生成图例项(用于ASIN控制列)
                    this.legendItems = this.filteredData.map((item, index) => {
                        const name = `${item.pm} (${item.asin})`;
                        const colors = [
                            '#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de',
                            '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc', '#2f4554',
                            '#61a0a8', '#d48265', '#91c7ae', '#749f83', '#c23531',
                            '#2f4554', '#61a0a8', '#d48265', '#91c7ae', '#749f83'
                        ];
                        return {
                            name: name,
                            asin: item.asin,
                            pm: item.pm,
                            country_code: item.country_code,
                            color: colors[index % colors.length],
                            visible: false, // 默认不显示
                            type: 'main'
                        };
                    });

                    // 只有在非切换天数的情况下才清空选中的ASIN列表
                    if (!isSwitchingDays) {
                        this.selectedForChart = [];
                    }
                    this.$message.info(`已获取 ${this.availableAsins.length} 个ASIN的数据${isSwitchingDays ? '，已更新为 ' + this.selectedDays + ' 天数据' : '，请点击ASIN控制列中的项目来显示或隐藏数据'}`);
                } else if (res.code === 201) {
                    // 处理分组下没有数据的情况
                    this.$message.warning(res.message || '该组下没有数据');
                    this.filteredData = [];
                    this.availableAsins = [];
                    this.legendItems = [];
                    this.selectedForChart = [];
                    this.hasChartData = false;
                } else {
                    this.$message.warning('没有可用的有效数据');
                    this.filteredData = [];
                    this.availableAsins = [];
                    this.legendItems = [];
                    this.selectedForChart = [];
                    this.hasChartData = false;
                }
            } catch (e) {
                this.$message.error('请求失败');
                this.hasChartData = false;
            } finally {
                this.isChartLoading = false;
            }
        },

        downloadChartData() {
            const option = this.myChart.getOption();
            const dateList = option.xAxis[0].data; // 获取日期列表（X轴数据）

            // 1. 构建CSV表头
            let csvHeader = '日期';
            const seriesNames = [];

            option.series.forEach(series => {
                const asinName = series.name; // 提取ASIN
                csvHeader += `,${asinName}`;
                seriesNames.push(series.name);
            });
            csvHeader += '\n';

            // 2. 构建CSV内容
            let csvContent = '';
            dateList.forEach((date, dateIndex) => {
                csvContent += date; // 日期列
                option.series.forEach(series => {
                    const value = series.data[dateIndex]?.value ?? 'N/A';
                    csvContent += `,${value}`;
                });

                csvContent += '\n';
            });

            // 3. 生成带时间戳的文件名
            const exportDate = dayjs().format('YYYYMMDD_HHmmss');
            const filename = `BSR数据_${exportDate}.csv`;

            // 4. 触发下载
            const blob = new Blob([csvHeader + csvContent], {
                type: 'text/csv;charset=utf-8;'
            });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = filename;
            link.click();
        },

        //数据处理方法，echarts需要数组，后端返回的是字符串，需要做处理
        processChartData(rawData) {
            if (!rawData || !rawData.length) {
                console.log('无有效数据');
                return [];
            }

            // 1. 首先在控制台输出原始数据
            console.log('原始数据:', JSON.parse(JSON.stringify(rawData)));

            // 2. 转换每个ASIN的数据
            const convertedData = rawData.map(item => {
                const convertedItem = {
                    asin: item.ASIN,
                    pm: item.pm,
                    country_code: item.country_code,
                    // 后端已返回数组，直接使用
                    ranks: Array.isArray(item.SalesRank_list) ? item.SalesRank_list : [],
                    dates: Array.isArray(item.date_list) ? item.date_list : [],
                    // 添加子类数据（如果有）
                    hasChildData: item.has_child_data || false
                };

                // 如果有子类数据
                if (convertedItem.hasChildData) {
                    convertedItem.childCategory = item.BSR_Child_Name;
                    convertedItem.childRanks = Array.isArray(item.BSR_Child_Rank_list) ? item.BSR_Child_Rank_list : [];
                }

                // 输出转换后的单个ASIN数据
                console.log(`转换后的ASIN数据(${item.ASIN}):`, JSON.parse(JSON.stringify(convertedItem)));

                return convertedItem;
            });

            // 3. 获取所有日期的并集
            const allDates = [...new Set(
                convertedData.flatMap(item => item.dates)
            )].sort((a, b) => new Date(a) - new Date(b));

            // console.log('所有日期序列:', allDates);

            // 4. 对齐数据：为每个ASIN填充缺失日期的值
            const processedData = convertedData.map(item => {
                // 主排名数据
                const dateToRank = {};
                item.dates.forEach((date, index) => {
                    dateToRank[date] = item.ranks[index];
                });

                // 子类排名数据（如果有）
                let dateToChildRank = {};
                if (item.hasChildData) {
                    item.dates.forEach((date, index) => {
                        dateToChildRank[date] = item.childRanks[index];
                    });
                }

                // 按统一日期序列填充数据
                const alignedRanks = allDates.map(date => ({
                    date,
                    value: dateToRank[date] !== undefined ? dateToRank[date] : null,
                    childValue: item.hasChildData ?
                        (dateToChildRank[date] !== undefined ? dateToChildRank[date] : null) :
                        null
                }));

                const result = {
                    ...item,
                    allDates,          // 统一日期序列
                    alignedRanks      // 对齐后的排名数据（包含主排名和子类排名）
                };

                // 输出处理后的单个ASIN数据
                console.log(`处理后的ASIN数据(${item.asin}):`, JSON.parse(JSON.stringify(result)));

                return result;
            });

            // 5. 最终输出处理后的完整数据
            console.log('最终处理后的数据:', JSON.parse(JSON.stringify(processedData)));
            return processedData;
        },
        // 选择天数
        async selectDays(days) {
            this.selectedDays = days;
            this.dateRange = [];

            // 保存当前已选择的ASIN列表（只保存asin用于后续匹配）
            const currentSelectedAsins = this.legendItems.filter(item => item.visible).map(item => item.asin);

            try {
                // 重新获取数据,并告知这是切换天数的场景
                await this.generateCharts(true);

                // 数据获取完成后,从新的legendItems中恢复选中的ASIN
                if (currentSelectedAsins.length > 0 && this.filteredData.length > 0) {
                    // 同步更新ASIN控制列的复选框状态
                    currentSelectedAsins.forEach(asin => {
                        const legendItem = this.legendItems.find(item => item.asin === asin);
                        if (legendItem) {
                            legendItem.visible = true;
                        }
                    });

                    // 基于所有visible为true的legendItems生成图表
                    const visibleAsins = this.legendItems.filter(item => item.visible).map(item => item.asin);
                    const chartData = this.filteredData.filter(item => visibleAsins.includes(item.asin));

                    if (chartData.length > 0) {
                        // 设置hasChartData为true,确保chartDom被渲染
                        this.hasChartData = true;

                        // 处理数据并渲染图表
                        this.$nextTick(() => {
                            const processed = this.processDataForChart(chartData);
                            this.chartData = processed;
                            this.initChart(processed);
                        });
                    }
                }
            } catch (error) {
                console.error('切换天数失败:', error);
            }
        },

        // 选择自定义天数

        // selectCustomDays() {
        //     if (this.customDays && !isNaN(this.customDays) && this.customDays > 0) {
        //         this.selectedDays = parseInt(this.customDays);
        //         this.updateListData();
        //         this.updateChartData();
        //     } else {
        //         this.$message.warning('请输入有效的天数');
        //     }
        // },

        // 日期范围变化处理
        async handleDateRangeChange(range) {
            if (range?.length === 2) {
                this.dateRange = range;
                this.selectedDays = null;

                // 保存当前已选择的ASIN列表（只保存asin用于后续匹配）
                const currentSelectedAsins = this.legendItems.filter(item => item.visible).map(item => item.asin);

                try {
                    // 重新获取数据,并告知这是切换日期范围的场景
                    await this.generateCharts(true);

                    // 数据获取完成后,从新的legendItems中恢复选中的ASIN
                    if (currentSelectedAsins.length > 0 && this.filteredData.length > 0) {
                        // 同步更新ASIN控制列的复选框状态
                        currentSelectedAsins.forEach(asin => {
                            const legendItem = this.legendItems.find(item => item.asin === asin);
                            if (legendItem) {
                                legendItem.visible = true;
                            }
                        });

                        // 基于所有visible为true的legendItems生成图表
                        const visibleAsins = this.legendItems.filter(item => item.visible).map(item => item.asin);
                        const chartData = this.filteredData.filter(item => visibleAsins.includes(item.asin));

                        if (chartData.length > 0) {
                            // 设置hasChartData为true,确保chartDom被渲染
                            this.hasChartData = true;

                            // 处理数据并渲染图表
                            this.$nextTick(() => {
                                const processed = this.processDataForChart(chartData);
                                this.chartData = processed;
                                this.initChart(processed);
                            });
                        }
                    }
                } catch (error) {
                    console.error('切换日期范围失败:', error);
                }
            }
        },

        //计算天数
        calculateDayCount(startDate, endDate) {
            // 使用dayjs处理日期（确保已安装dayjs）
            const start = dayjs(startDate);
            const end = dayjs(endDate);
            // 计算天数差（包含首尾所以+1）
            return end.diff(start, 'day') + 1;
        },

        // 根据日期范围筛选数据
        filterByDateRange(startDate, endDate) {
            if (!this.rawChartData?.length) return []; // 确保返回数组

            const start = new Date(startDate);
            const end = new Date(endDate);

            // 返回新数组（不修改this.filteredData）
            return this.rawChartData.map(item => {
                const dates = item.date_list?.split(',') || [];
                const ranks = item.SalesRank_list?.split(',') || [];

                const filtered = dates.map((date, index) => ({
                    date,
                    rank: ranks[index],
                    isInRange: new Date(date) >= start && new Date(date) <= end
                })).filter(item => item.isInRange);

                return {
                    ...item,
                    filteredDates: filtered.map(d => d.date),
                    filteredRanks: filtered.map(d => d.rank),
                    dayCount: filtered.length
                };
            });
        },

        // 使用筛选后的数据更新图表
        updateChartWithFilteredData() {
            if (!this.filteredData || !this.filteredData.length) return;

            // 处理数据用于图表显示
            const processedData = this.processDataForChart(this.filteredData);
            // console.log('processedData', processedData)
            this.initChart(processedData);
        },

        // 重置筛选数据
        resetFilteredData() {
            if (!this.rawChartData) return;

            this.filteredData = this.rawChartData.map(item => ({
                ...item,
                filteredDates: item.date_list.split(','),
                filteredRanks: item.SalesRank_list.split(','),
                dayCount: item.date_list.split(',').length
            }));

            this.updateChartWithFilteredData();
        },

        processDataForChart(filteredData) {
            if (!filteredData || !filteredData.length) return [];

            // 获取所有日期的并集
            const allDates = [...new Set(
                filteredData.flatMap(item => item.filteredDates)
            )].sort((a, b) => new Date(a) - new Date(b));

            // 处理每个ASIN的数据
            return filteredData
                .filter(item => {
                    // 只保留主排名或子类排名有数据的
                    const hasMain = item.filteredRanks && item.filteredRanks.some(r => r && r !== '' && r !== 'null');
                    const hasChild = item.BSR_Child_Rank && item.BSR_Child_Rank.some(r => r && r !== '' && r !== 'null');
                    return hasMain || hasChild;
                })
                .map(item => {
                    const dateRankMap = {};
                    item.filteredDates.forEach((date, index) => {
                        dateRankMap[date] = item.filteredRanks[index];
                    });

                    // 子类排名
                    let childRankMap = {};
                    if (item.BSR_Child_Rank && item.BSR_Child_Rank.length) {
                        item.filteredDates.forEach((date, idx) => {
                            childRankMap[date] = item.BSR_Child_Rank[idx];
                        });
                    }

                    // 对齐数据
                    const alignedRanks = allDates.map(date => ({
                        date,
                        value: dateRankMap[date] !== undefined ? dateRankMap[date] : null,
                        childValue: childRankMap[date] !== undefined ? childRankMap[date] : null
                    }));

                    return {
                        ...item,
                        allDates,
                        alignedRanks,
                        hasChildData: !!(item.BSR_Child_Rank && item.BSR_Child_Rank.length),
                        childCategory: item.BSR_Child_Name
                    };
                });
        },

        // 更新列表数据
        updateListData() {
            if (!this.rawChartData || !this.rawChartData.length) return;

            this.filteredData = this.rawChartData.map(item => {
                // 基础数据（始终保留）
                const baseData = {
                    asin: item.ASIN || item.asin,
                    pm: item.pm,
                    country_code: item.country_code,
                    BSR_Child_Name: item.BSR_Child_Name,
                    BSR_Child_Rank: item.BSR_Child_Rank_list || [],
                    hasChildData: item.has_child_data || false
                };

                // 日期和排名数据（后端已返回为数组）
                const dates = Array.isArray(item.date_list) ? item.date_list : [];
                const ranks = Array.isArray(item.SalesRank_list) ? item.SalesRank_list : [];
                const childRanks = Array.isArray(item.BSR_Child_Rank_list) ? item.BSR_Child_Rank_list : [];

                // 根据当前筛选模式处理数据
                if (this.dateRange && this.dateRange.length === 2) {
                    // 日期范围筛选模式
                    const [startDate, endDate] = this.dateRange;
                    const start = new Date(startDate);
                    const end = new Date(endDate);

                    const filteredData = dates.map((date, index) => ({
                        date,
                        rank: ranks[index],
                        childRank: childRanks[index],
                        isInRange: new Date(date) >= start && new Date(date) <= end
                    })).filter(item => item.isInRange);

                    return {
                        ...baseData,
                        filteredDates: filteredData.map(item => item.date),
                        filteredRanks: filteredData.map(item => item.rank),
                        BSR_Child_Rank: filteredData.map(item => item.childRank)
                    };
                } else {
                    // 天数筛选模式（默认）
                    return {
                        ...baseData,
                        filteredDates: dates.slice(-this.selectedDays),
                        filteredRanks: ranks.slice(-this.selectedDays),
                        BSR_Child_Rank: childRanks.slice(-this.selectedDays)
                    };
                }
            });
        },

        // 点击天数更新图表数据
        updateChartData() {
            if (!this.chartData || !this.chartData.length) return;

            // 处理数据以显示最近N天的信息
            const filteredChartData = this.chartData.map(asinData => {
                const n = this.selectedDays;
                return {
                    ...asinData,
                    // 保留最近N天的数据
                    alignedRanks: asinData.alignedRanks.slice(-n),
                    allDates: asinData.allDates.slice(-n)
                };
            });

            // 重新渲染图表
            this.initChart(filteredChartData);
        },

        // 初始化图表
        initChart(processedData) {
            console.log('最开始要调用的数据格式', processedData)
            if (!this.$refs.chartDom || !processedData?.length) return;

            // 销毁旧图表实例
            if (this.myChart) {
                this.myChart.dispose();
            }

            // 默认显示最近 selectedDays 天
            const days = this.selectedDays || 30;

            // 只取最近days天的数据
            const slicedData = processedData.map(asinData => {
                const alignedRanks = asinData.alignedRanks.slice(-days);
                return { ...asinData, alignedRanks };
            });

            // x轴日期
            const allDates = slicedData[0].alignedRanks.map(item => item.date);

            // 2. 动态生成series（主排名和子类排名）
            const series = [];
            const legendItems = [];

            // 定义颜色数组（与ASIN控制列保持一致）
            const colors = [
                '#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de',
                '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc', '#2f4554',
                '#61a0a8', '#d48265', '#91c7ae', '#749f83', '#c23531',
                '#2f4554', '#61a0a8', '#d48265', '#91c7ae', '#749f83'
            ];

            // 根据ASIN在legendItems中的索引获取颜色
            const getColorByAsin = (asin) => {
                const index = this.legendItems.findIndex(item => item.asin === asin);
                return index >= 0 ? colors[index % colors.length] : colors[0];
            };


            // 添加主排名系列
            slicedData.forEach(asinData => {
                // 主排名有效数据判断（排除为 NaN 的情况）
                const hasMain = asinData.alignedRanks.some(item => {
                    const v = item.value;
                    return v !== null && v !== '' && v !== 'null' && !isNaN(Number(v));
                });
                // 子类排名有效数据判断（排除为 NaN 的情况）
                const hasChild = asinData.alignedRanks.some(item => {
                    const v = item.childValue;
                    return v !== null && v !== '' && v !== 'null' && !isNaN(Number(v));
                });

                // 如果有主排名数据，显示主排名；否则如果有子类数据，显示子类
                const asinColor = getColorByAsin(asinData.asin);
                if (hasMain) {
                    const mainSeries = {
                        name: `${asinData.pm} (${asinData.asin})`,
                        type: 'line',
                        symbol: 'circle',
                        symbolSize: 6,
                        connectNulls: false,
                        data: asinData.alignedRanks.map(item => ({
                            name: item.date,
                            value: (item.value !== null && item.value !== '' && item.value !== 'null' &&
                                !isNaN(Number(item.value)) && Number(item.value) !== 0)
                                ? Number(item.value)
                                : null
                        })),
                        lineStyle: { width: 2 },
                        itemStyle: { color: asinColor },
                        show: true
                    };
                    series.push(mainSeries);
                    legendItems.push({
                        name: mainSeries.name,
                        visible: true,
                        type: 'main'
                    });
                } else if (asinData.hasChildData && hasChild) {
                    // 没有主排名数据，但有子类数据，则显示子类
                    const childSeries = {
                        name: `${asinData.pm} (${asinData.asin}) - ${asinData.childCategory}`,
                        type: 'line',
                        symbol: 'diamond',
                        symbolSize: 8,
                        connectNulls: false,
                        data: asinData.alignedRanks.map(item => ({
                            name: item.date,
                            value: (item.childValue !== null && item.childValue !== '' && item.childValue !== 'null' &&
                                !isNaN(Number(item.childValue)) && Number(item.childValue) !== 0)
                                ? Number(item.childValue)
                                : null,
                            childCategory: asinData.childCategory
                        })),
                        lineStyle: {
                            width: 2,
                            type: 'dashed'
                        },
                        itemStyle: { color: asinColor },
                        show: true  // 改为 true，因为没有主排名时显示子类
                    };
                    series.push(childSeries);
                    legendItems.push({
                        name: childSeries.name,
                        visible: true,  // 改为 true
                        type: 'child'
                    });
                }
            });

            const sortedLegendItems = legendItems.sort((a, b) => {
                // 1. 提取两个图例名称的“数字-”前缀（如“1-产品A (ASIN1)”提取“1”）
                const aMatch = a.name?.match(/^\d+/); // 匹配名称开头的数字
                const bMatch = b.name?.match(/^\d+/);

                // 确认是否为“数字-”格式（避免仅数字无横杠的误判，如“123产品”不匹配）
                const aHasPrefix = !!aMatch && a.name.startsWith(`${aMatch[0]}-`);
                const bHasPrefix = !!bMatch && b.name.startsWith(`${bMatch[0]}-`);

                // 2. 优先级1：带“数字-”前缀的排在前面
                if (aHasPrefix && !bHasPrefix) return -1;
                if (!aHasPrefix && bHasPrefix) return 1;

                // 3. 优先级2：同是“数字-”前缀，按数字升序排列（如“1-xxx”→“2-xxx”）
                if (aHasPrefix && bHasPrefix) {
                    const aNum = parseInt(aMatch[0], 10);
                    const bNum = parseInt(bMatch[0], 10);
                    return aNum - bNum;
                }

                // 4. 优先级3：都没有“数字-”前缀，保持原顺序（也可按名称拼音排序，可选）
                return 0;
            });




            console.log('经过Series处理后的数据', series)

            // 3. 配置图表选项
            const option = {
                title: {
                    text: `ASIN销售排名趋势对比`,
                    left: 'center'
                },
                tooltip: {
                    trigger: 'axis',
                    formatter: params => {
                        const date = params[0].axisValue;
                        let html = `<div style="margin-bottom:5px;font-weight:bold">${date}</div>`;

                        params.forEach(param => {
                            const isChild = param.seriesName.includes(' - ');
                            const value = param.data.value ?? '无数据';
                            const color = param.color;

                            if (!isChild) {
                                // 主排名
                                html += `
<div style="display:flex;align-items:center;margin:3px 0">
  <span style="display:inline-block;width:10px;height:10px;border-radius:50%;background:${color};margin-right:6px"></span>
  ${param.seriesName}: <span style="margin-left:5px;font-weight:bold">${value}</span>
</div>`;
                            } else {
                                // 子类排名：从 param.data 中读取 childCategory
                                const childName = param.data.childCategory || '未知子类';
                                html += `
<div style="display:flex;align-items:center;margin:3px 0 3px 15px">
  <span style="display:inline-block;width:10px;height:10px;border-radius:2px;background:${color};margin-right:6px"></span>
  ${param.seriesName}(子类): <span style="margin-left:5px;font-weight:bold">${value}</span>
</div>`;
                            }
                        });

                        return html;
                    }
                },
                legend: {
                    type: 'scroll',
                    bottom: 10,
                    itemWidth: 12,
                    itemHeight: 12,
                    data: legendItems.map(item => ({
                        name: item.name,
                        icon: item.type === 'child' ? 'diamond' : 'circle'
                    })),
                    selected: legendItems.reduce((acc, item) => {
                        acc[item.name] = item.visible;
                        return acc;
                    }, {})
                },
                grid: {
                    top: 60,
                    left: 60,
                    right: 30,
                    bottom: 40,
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: allDates,
                    axisLabel: {
                        formatter: date => dayjs(date).format('MM-DD')
                    }
                },
                yAxis: {
                    type: 'value',
                    inverse: false,
                    name: '销售排名',
                    nameGap: 20,
                    min: value => Math.max(0, value.min - 10)
                },
                series: series
            };

            console.log('配置项', option)

            // 4. 渲染图表
            // 初始化新图表
            this.myChart = echarts.init(this.$refs.chartDom);
            this.myChart.setOption(option);

            // 监听图例切换事件(注意:这里只影响图表显示,不影响ASIN控制列)
            this.myChart.on('legendselectchanged', (params) => {
                // 更新图表中选中的ASIN状态,但不影响ASIN控制列
                // ASIN控制列保持完整,由generateCharts管理
            });
        },



        // 点击图例项
        handleLegendClick(index) {
            console.log(index)
            const item = this.legendItems[index];
            // console.log(item)
            item.visible = !item.visible;    //点击后为false是控制前面选项框的

            // 基于所有visible为true的legendItems生成图表
            const visibleAsins = this.legendItems.filter(item => item.visible).map(item => item.asin);
            const chartData = this.filteredData.filter(item => visibleAsins.includes(item.asin));

            if (chartData.length > 0) {
                // 设置hasChartData为true,确保chartDom被渲染
                this.hasChartData = true;

                // 处理数据并渲染图表
                this.$nextTick(() => {
                    const processed = this.processDataForChart(chartData);
                    this.chartData = processed;
                    this.initChart(processed);
                });
            } else {
                // 清空图表
                if (this.myChart) {
                    this.myChart.dispose();
                    this.myChart = null;
                }
                this.chartData = null;
                this.hasChartData = false;
            }
        },

        // 重置图表
        resetChart() {
            if (this.myChart) {
                this.myChart.dispose();
                this.myChart = null;
            }
            this.chartData = null;
            this.hasChartData = false;
            this.$message.success('已重置图表');
        },

        //获取选项管理数据
        showEditDialog() {
            this.editDialogVisible = true;
            this.editDialogTitle = '选项管理';
            this.initData();
            // 重置搜索状态
            this.asinSearchQuery = '';
            this.groupSearchQuery = '';
            this.searchAsin();
            this.searchGroup();
        },

        searchAsin() {

            if (!this.asinSearchQuery.trim()) {
                this.filteredAsinList = this.asinDetail;


                this.filteredAsinList = [...this.asinDetail].sort((a, b) => {
                    // 提取产品名称中的数字前缀（如"123-xxx"中的123）
                    const aMatch = a.pm?.match(/^\d+/);
                    const bMatch = b.pm?.match(/^\d+/);

                    const aHasNumberPrefix = !!aMatch;
                    const bHasNumberPrefix = !!bMatch;

                    // 分组排序：有数字-前缀的排在前面
                    if (aHasNumberPrefix && !bHasNumberPrefix) {
                        return -1;
                    }
                    if (!aHasNumberPrefix && bHasNumberPrefix) {
                        return 1;
                    }

                    // 都是有数字-前缀的情况：按数字升序排列
                    if (aHasNumberPrefix && bHasNumberPrefix) {
                        const aNum = parseInt(aMatch[0], 10);
                        const bNum = parseInt(bMatch[0], 10);
                        return aNum - bNum; // 升序（从小到大）
                    }

                    // 都没有数字-前缀：保持原顺序或按其他规则排序
                    return 0;
                });



                return;
            }

            const query = this.asinSearchQuery.toLowerCase();
            this.filteredAsinList = this.asinDetail.filter(item => {
                // 同时匹配ASIN和产品名称
                return (
                    item.asin.toLowerCase().includes(query) ||
                    (item.pm && item.pm.toLowerCase().includes(query))
                );
            });





        },

        // 组搜索
        searchGroup() {
            if (!this.groupSearchQuery.trim()) {
                // 搜索词为空时显示所有组
                this.filteredGroupList = this.editgroupList;
                return;
            }

            const query = this.groupSearchQuery.toLowerCase();
            this.filteredGroupList = this.editgroupList.filter(group => {
                // 匹配组名
                return group.分组.toLowerCase().includes(query);
            });
        },

        // 开始编辑组名
        startGroupEdit(row) {
            this.$set(row, 'isEditing', true)
            this.$set(row, 'editName', row.分组) // 初始化编辑值
        },

        // 确认修改组名
        async confirmGroupEdit(row) {
            try {
                if (!row.editName || row.editName.trim() === row.分组) {
                    row.isEditing = false
                    return
                }
                console.log(row)
                row.isSaving = true
                const res = await this.$axios.post('/vue/vue_bsr/RenameBsrgroup', {
                    id: row.id,
                    new_name: row.editName.trim(),
                    old_name: row.分组
                })

                if (res.code === 200) {
                    this.$message.success('组名修改成功')
                    row.分组 = row.editName
                    row.isEditing = false
                    this.initData();
                    // this.searchAsin();
                }
            } catch (error) {
                this.$message.error('修改失败: ' + error.message)
            } finally {
                row.isSaving = false
            }
        },

        //显示上传bsr文件窗口
        showturnbsrpage(fullname) {
            // console.log(fullname)
            this.currentFullname = fullname;
            this.showbsrpage = true;
            this.showbsrpagetitle = '上传BSR文件';

            // 确保至少有一个任务
            if (this.tasks.length === 0) {
                this.addTask();
            }

            // 确保每个任务都有最新的分组和ASIN数据
            this.tasks.forEach(task => {
                // 如果任务已有分组ID，确保ASIN选项是最新的
                if (task.groupId) {
                    // 检查分组是否仍然存在
                    const groupExists = this.groupDetail.some(group => group.id === task.groupId);
                    if (!groupExists) {
                        task.groupId = '';
                        task.asin = '';
                        task.file = null;
                        task.fileName = '';
                    } else {
                        // 检查ASIN是否仍然属于该分组
                        if (task.asin) {
                            const asinExists = this.asinDetail.some(
                                item => item.asin === task.asin && item.分组id === task.groupId
                            );
                            if (!asinExists) {
                                task.asin = '';
                                task.file = null;
                                task.fileName = '';
                            }
                        }
                    }
                }
            });
        },


        //bsr对话框处理方法
        handleAsinChange(task) {
            if (task.asin) {
                // 根据选中的ASIN查找对应的产品名称
                const selectedAsin = this.asinDetail.find(item => item.asin === task.asin);
                if (selectedAsin) {
                    task.pm = selectedAsin.pm; // 更新pm字段
                    console.log(take)
                }
            } else {
                task.pm = ''; // 清空pm字段
            }
            // 清空文件相关字段
            task.file = null;
            task.fileName = '';
        },
        //获取分组对应的asin
        getAsinOptions(groupId) {
            console.log('获取到的groupId的值：', groupId)
            if (!groupId) return [];
            return this.asinDetail.filter(item => item.分组 === groupId);
        },

        // 分组变化时的处理
        handleGroupChange(task) {
            // 当分组改变时，清空已选的ASIN
            task.asin = '';
            task.file = null;
            task.fileName = '';
            task.pm = '';
        },

        // 添加新任务
        addTask() {
            this.tasks.push({
                id: Date.now(), // 唯一ID
                groupId: '',
                asin: '',
                file: null,
                fileName: '',
                originalFileName: '', // 新增：用户选择的原始文件名
                pm: ''
            })
        },

        // 删除任务
        removeTask(index) {
            this.tasks.splice(index, 1)
        },

        // 处理文件选择
        handleFileChange(file, task) {
            const [asin, pmWithCountry] = this.currentFullname.split('+');
            if (!asin || !pmWithCountry) {
                this.$message.error('ASIN数据格式无效');
                return false;
            }

            // 从 pmWithCountry 中提取纯品名，去掉括号内的国家信息
            // 格式如 "品名(US)" -> "品名"
            const countryMatch = pmWithCountry.match(/(.+)\((.+)\)$/);
            let pm = countryMatch ? countryMatch[1] : pmWithCountry;

            // 确保文件名中不包含任何括号（去掉品名中可能存在的括号）
            pm = pm.replace(/[()（）]/g, '');

            // console.log('检索到的文件名', file.name)
            // console.log('未选择文件前的task', task)
            task.originalFileName = file.name

            // 生成新文件名（不包含括号）
            const newName = `${pm}+${asin}.csv`

            // 更新任务信息
            task.file = file.raw
            task.fileName = newName
            // console.log('更新后的文件名', task.fileName)
            // console.log('选择文件后的', task)
            return false // 阻止自动上传
        },

        // 提交所有任务
        async submitAllTasks() {
            const [asin, pmWithCountry] = this.currentFullname.split('+');
            // 从 pmWithCountry 中提取纯品名和国家，格式如 "品名(US)"
            const countryMatch = pmWithCountry.match(/(.+)\((.+)\)$/);
            const pm = countryMatch ? countryMatch[1] : pmWithCountry;
            const country = countryMatch ? countryMatch[2] : '';

            this.isSubmitting = true;
            try {
                const formData = new FormData();
                const uploadTime = new Date().toISOString();
                // 异步处理所有任务
                await Promise.all(this.tasks.map(async (task) => {
                    // 1. 将File对象转为Base64
                    const fileBase64 = await new Promise((resolve) => {
                        const reader = new FileReader();
                        reader.onload = () => resolve(reader.result);
                        reader.readAsDataURL(task.file); // 转为Base64
                    });

                    // 2. 构造可序列化的数据对象
                    const taskData = {
                        file: fileBase64, // 使用Base64格式的文件数据
                        metaData: {
                            asin: asin,
                            productName: pm,
                            country: country,
                            filetype: task.fileFormat,
                            originalFileName: task.originalFileName,
                            generatedFileName: task.fileName,
                            uploadTime: this.formatDateTime(uploadTime)
                        }
                    };

                    // 3. 创建Blob并添加到FormData
                    const blob = new Blob(
                        [JSON.stringify(taskData)],
                        { type: 'application/json' }
                    );
                    formData.append('tasks[]', blob, task.fileName);
                }));

                // 4. 执行上传
                await this.$axios.post('/vue/bsr_d/bsr_d_upload', formData, {
                    headers: { 'Content-Type': 'multipart/form-data' },
                    withCredentials: true
                });
                this.resetToDefault();
                this.$message.success(`成功上传 ${this.tasks.length} 个文件`);
            } catch (error) {
                this.$message.error('上传失败: ' + error.message);
            } finally {
                this.isSubmitting = false;
            }
        },

        // 4. 新增重置方法
        resetToDefault() {
            this.tasks = [{
                asin: this.currentFullname.split('+')[0] || '', // 保留ASIN部分
                pm: this.currentFullname.split('+')[1] || '',  // 保留产品名称部分
                file: null,
                fileFormat: '', // 默认选择新格式
                fileName: '',
                originalFileName: ''
            }];
        },

        clearAll() {
            this.firstSelectValue = '';
            this.secondSelectValue = '';
            this.searchText = '';
            this.$message.info('已清除所有选择');
            this.resetChart();
            this.filteredData = [];
            this.legendItems = [];
            this.availableAsins = [];
        },



        // 添加组操作
        async addGroup() {
            try {
                // 表单验证
                if (!this.newgroupname || this.newgroupname.trim().length < 2) {
                    this.$message.error('组名称至少需要2个字符');
                    return;
                }

                // 调用后端接口
                const res = await this.$axios.post('/vue/vue_bsr/AddBsrgroup', this.newgroupname);

                if (res.code === 200) {
                    this.$message.success(res.message || '组添加成功');
                    this.newGroupForm.name = '';  // 清空表单

                    // 关键：等待数据刷新完成
                    await this.initData();

                    // 执行搜索刷新表格
                    this.searchGroup();
                } else if (res.code === 401) {
                    this.$message.warning(res.message);
                } else {
                    this.$message.error(res.message || '操作失败');
                }
            } catch (error) {
                this.$message.error('请求失败: ' + error.message);
            }
        },

        // 管理组内asin方法
        async manageAsins(row) {
            console.log(row)
            this.currentGroup = row.分组;
            console.log(this.currentGroup)
            const res = await this.$axios.post(`/vue/bsr_d/bsr_d_all/${this.currentGroup}`)
            console.log(res.data)
            this.manageAsinDialogVisible = true;
            this.groupAsins = res.data.asin_list; // 使用浅拷贝避免直接修改原数据
            this.newAsinForm = { asin: '', productName: '' };
        },

        // 添加ASIN到当前分组
        async addAsinToGroup() {
            // 1. 验证表单数据
            if (!this.groupAsinForm.asin) {
                this.$message.warning('请选择ASIN');
                return;
            }

            // 2. 根据选中的id在asinDetail中查找对应的记录（确保类型一致）
            const selectedId = Number(this.groupAsinForm.asin);
            const selectedItem = this.asinDetail.find(item => Number(item.id) === selectedId);
            if (!selectedItem) {
                this.$message.warning('未找到对应的ASIN信息');
                return;
            }

            const { asin, pm, country } = selectedItem;
            console.log('提取结果:', { asin, pm, country, id: selectedItem.id })

            // 3. 检查ASIN是否已存在（比较asin部分）
            if (this.groupAsins.some(item => item.asin === asin)) {
                this.$message.warning('该ASIN已存在于当前分组');
                return;
            }
            try {
                // 4. 调用接口，包含 id、country_code
                const res = await this.$axios.post('/vue/vue_bsr/addasintogroup', {
                    groupId: this.currentGroup,
                    id: selectedItem.id,   // ASIN对应的id
                    asin: asin,            // ASIN
                    pm: pm,               // 纯品名（不包含国家）
                    country_code: country // 国家
                });
                if (res.code === 200) {
                    this.$message.success('添加成功');
                    // 5. 更新本地数据，包含完整字段
                    this.groupAsins.push({
                        id: (res.data && res.data.id) || selectedItem.id,
                        asin_id: selectedItem.id,
                        asin: asin,
                        pm: pm,
                        country: country,
                        position: null,
                        is_sorted: false,
                        sort_status: '待排序'
                    });
                    // 清空选择
                    this.groupAsinForm.asin = '';
                }
            } catch (error) {
                this.$message.error('添加失败: ' + error.message);
            }
        },

        // 拖拽结束事件
        onDragEnd() {
            console.log('拖拽结束，当前排序:', this.groupAsins.map(item => item.asin));
        },

        // 保存排序到后端
        async saveAsinOrder() {
            if (!this.currentGroup) {
                this.$message.warning('未选择分组');
                return;
            }

            this.isSavingOrder = true;
            try {
                // 构建排序数据：id 和新的 position
                const orderData = this.groupAsins.map((item, index) => ({
                    id: item.id,
                    asin_id: item.asin_id,
                    position: index + 1
                }));
                console.log('准备发送的排序组:', this.currentGroup)
                console.log('准备发送的排序数据:', orderData)
                const res = await this.$axios.post('/vue/vue_bsr/update_position', {
                    groupName: this.currentGroup,
                    orderList: orderData
                });

                if (res.code === 200) {
                    this.$message.success('排序保存成功');
                    // 更新本地数据的 position 和 is_sorted 状态
                    this.groupAsins = this.groupAsins.map((item, index) => ({
                        ...item,
                        position: index + 1,
                        is_sorted: true,
                        sort_status: `第${index + 1}位`
                    }));
                } else {
                    this.$message.error(res.message || '保存失败');
                }
            } catch (error) {
                this.$message.error('保存排序失败: ' + error.message);
            } finally {
                this.isSavingOrder = false;
            }
        },

        // 从分组中删除ASIN
        async removeAsinFromGroup(asinId) {
            try {
                await this.$confirm('确定要从分组中删除此ASIN吗?', '提示', {
                    type: 'warning'
                });
                console.log(asinId)
                const res = await this.$axios.post(`/vue/vue_bsr/deleteasintogroup/${asinId}`);
                if (res.code === 200) {
                    this.$message.success('删除成功');
                    // 从列表中移除
                    this.groupAsins = this.groupAsins.filter(item => item.asin !== asinId);
                }
            } catch (error) {
                if (error !== 'cancel') {
                    this.$message.error('删除失败: ' + error.message);
                }
            }
        },

        //删除组操作
        async handleDeleteGroup(rowData) {
            console.log(rowData)
            await this.$confirm(`确定删除组 "${rowData.分组}" 吗？`, '警告', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            });
            try {
                // console.log(`确定删除组 "${rowData.分组key}"`)
                // 确认对话框
                const res = await this.$axios.post(`/vue/vue_bsr/DeleteBsrgroup/${rowData.分组}`);
                // console.log(res)
                if (res.code === 200) {
                    this.$message.success(res.message)
                    await this.initData();
                    this.searchGroup();
                } else {
                    this.$message.error(error.message)
                }
            } catch (error) {
                this.$message.error('请求失败', error.message)
            }
        },

        // ASIN操作
        async addAsin() {
            try {
                const uploadTime = new Date().toISOString();
                this.newAsinForm.uploadTime = this.formatDateTime(uploadTime);
                // console.log(this.newAsinForm)
                if (!this.newAsinForm.productName || !this.newAsinForm.asin) {
                    this.$message.warning('请填写完整信息');
                    return;
                }
                // 2. 检查ASIN是否已存在（核心逻辑）
                const newAsin = this.newAsinForm.asin.trim().toUpperCase(); // 标准化ASIN（去空格+大写）
                const newCountry = this.newAsinForm.country.trim().toUpperCase();
                const isDuplicate = this.asinDetail.some(item =>
                    item.asin.toUpperCase() === newAsin && item.country.toUpperCase() === newCountry
                );

                if (isDuplicate) {
                    this.$message.warning('该ASIN已存在，请勿重复添加');
                    return;
                }
                const res = await this.$axios.post('/vue/vue_bsr/AddAsin', this.newAsinForm);
                if (res.code === 200) {
                    this.$message.success(res.message)
                    await this.initData();
                    this.searchAsin();
                } else {
                    this.$message.error(res.message)
                }
            } catch {
                this.$message.error('请求失败', res.message)
            }
        },

        //删除asin方法
        async handleDeleteAsin(rowData) {
            console.log(rowData)  //获取要删除的对应的id
            await this.$confirm(`确定删除该ASIN"${rowData.asin}+${rowData.pm}+${rowData.country}" 吗？`, '警告', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            });
            try {
                const res = await this.$axios.post(`/vue/vue_bsr/DeleteAsin/${rowData.asin}+${rowData.country}`)
                if (res.code === 200) {
                    this.$message.success(res.message)
                    await this.initData();
                    this.searchAsin();
                } else {
                    this.$message.error(res.message)
                }
            } catch {
                this.$message.error('请求失败', res.message)
            }
        },

        // 开始编辑
        startEdit(row) {
            row.isEditing = true;
            row.editAsin = row.asin;
            row.editPm = row.pm;
            row.originalAsin = row.asin;
        },
        // 取消编辑
        cancelEdit(row) {
            row.isEditing = false;
            this.$message.info('已取消编辑');
        },
        // 确认修改
        async confirmEdit(row) {
            try {
                // 基础验证
                if (!row.editAsin.trim()) {
                    this.$message.warning('ASIN不能为空');
                    return;
                }
                const res = await this.$axios.post('/vue/vue_bsr/UpdateAsin', {
                    id: row.id,
                    asin: row.editAsin,
                    pm: row.editPm,
                    country: row.editCountry
                });
                if (res.code === 200) {
                    this.$message.success(res.message)
                    await this.initData()
                    this.searchAsin()
                } else {
                    this.$message.error(res.message)
                }
            } catch (error) {
                this.$message.error('修改失败: ' + error.message);
            } finally {
                row.isEditing = false;
                row.isSaving = false;
            }
        },
        // 输入框变化时触发防抖搜索
        handleSearchInput() {
            // 清除之前的计时器
            clearTimeout(this.searchDebounceTimer);
            // 立即显示结果
            this.showResults = this.searchText.length > 0;
            // 设置2秒后隐藏的防抖
            this.searchDebounceTimer = setTimeout(() => {
                if (!this.isMouseOverResults) { // 检查鼠标是否在结果区域
                    this.showResults = false;
                }
            }, 2000);
            if (this.searchText.trim()) {
                this.isSearching = true;
                this.debouncedSearch();
            } else {
                this.searchResults = [];
                this.searchPerformed = false;
            }
        },
        // 手动点击搜索按钮
        executeSearch() {
            if (this.searchText.trim()) {
                this.searchDatabase();
            }
        },

        keepResultsVisible() {
            this.isMouseOverResults = true;
            this.showResults = true;
            clearTimeout(this.searchDebounceTimer); // 取消隐藏计时
        },

        // 鼠标移出隐藏
        hideResults() {
            this.isMouseOverResults = false;
            setTimeout(() => {
                if (!this.isMouseOverResults) {
                    this.showResults = false;
                }
            }, 300); // 添加微小延迟防止误触
        },

        // 实际搜索方法
        async searchDatabase() {
            try {
                const response = await this.$axios.get('/vue/vue_bsr/Search', {
                    params: { keyword: this.searchText.trim() }
                });
                this.searchResults = response.data || [];
                this.searchPerformed = true;
            } catch (error) {
                this.$message.error('搜索失败: ' + error.message);
            } finally {
                this.isSearching = false;
            }
        },

        // 搜索点击结果行
        async handleResultClick(row) {
            // console.log('选中结果:', typeof (row.asin));
            const data = await this.$axios.post('/vue/vue_bsr/singleasinsearch', {
                asin: row.ASIN
            })
            if (data.code === 200) {
                this.$message.success(data.message)
                this.hasChartData = true;
                this.$nextTick(() => {
                    this.chartData = this.processChartData(data.data);
                    this.rawChartData = data.data;
                    this.initChart(this.chartData);
                    this.updateListData();
                });
            }
        }
    }
}
</script>

<style scoped>
.main {
    width: 95.5vw;
    height: 100vh;
    background-color: #f5f5f5;
    padding: 10px;
}

.bsrmanage {
    display: flex;
    width: 1815px;
    height: 7%;
    align-items: center;
    background-color: white;
    padding: 0 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
}

.fistselect {
    height: 100%;
    width: 18%;
    display: flex;
    align-items: center;
    padding-right: 10px;
}

/* 下拉框样式 */
.secoundselect {
    position: relative;
    width: 480px;
}

.default-prompt {
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f5f7fa;
    border: 1px dashed #dcdfe6;
    border-radius: 4px;
    color: #909399;
    font-size: 14px;
    cursor: not-allowed;
}

/* 选择器选项内容样式 */
.select-option-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 0 4px;
}

.option-main-text {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.option-country-tag {
    display: inline-block;
    padding: 2px 8px;
    margin-left: 12px;
    color: #606266;
    border-radius: 4px;
    font-size: 13px;
    font-weight: bold;
    white-space: nowrap;
}


/* 选项复选框样式 */
.el-select-dropdown__item .el-checkbox {
    margin-left: 10px;
}

/* 生成按钮样式 */
.el-select-dropdown__footer {
    padding: 8px;
    background: #f5f7fa;
}

/* 缩小按钮尺寸 */
.el-select .el-button {
    padding: 8px 12px;
    margin-left: 10px;
    transform: scale(0.9);
}

.editbutton {
    height: 100%;
    width: 8%;
    display: flex;
    align-items: center;
    padding-right: 10px;
    margin-left: 10%;
}

.bsrpushbutton {
    height: 100%;
    width: 8%;
    display: flex;
    align-items: center;
    padding-right: 10px;
}

.cleanall {
    height: 100%;
    width: 8%;
    display: flex;
    align-items: center;
    padding-right: 10px;
    margin-left: 2%;
}

.search-container {
    position: relative;
    width: 100%;
    max-width: 600px;
    margin: 0 auto;
    z-index: 1;

    .searchbox {
        .el-input {
            height: 40px;
            /* 固定高度 */
        }
    }

    .search-results {
        position: absolute;
        top: 100%;
        left: 0;
        width: 100%;
        max-height: 400px;
        overflow-y: auto;
        background: white;
        border: 1px solid #ebeef5;
        border-radius: 4px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
        z-index: 1000;
        margin-top: 5px;

        .el-table {
            width: 100%;

            &::before {
                display: none;
            }

            .el-table__row {
                cursor: pointer;

                &:hover {
                    background-color: #f5f7fa;
                }
            }
        }

        &::-webkit-scrollbar {
            width: 6px;
        }

        &::-webkit-scrollbar-thumb {
            background: #c1c1c1;
            border-radius: 3px;
        }
    }

    .no-results {
        position: absolute;
        top: 100%;
        left: 0;
        width: 100%;
        padding: 20px;
        text-align: center;
        color: #909399;
        background: white;
        border: 1px solid #ebeef5;
        border-radius: 4px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
        z-index: 1000;
        margin-top: 5px;
    }
}

.datebox {
    width: 1810px;
    height: 85%;
    display: flex;
    margin-top: 10px;
    background-color: white;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
}

.datadisplay {
    width: 80%;
    height: 92%;
    margin-top: 1%;
    margin-left: 2%;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px dashed #ddd;
    border-radius: 4px;
}

.datalist {
    width: 20%;
    height: 100%;
    padding: 10px;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
}

.datahead {
    width: 100%;
    padding: 10px 0;
    text-align: center;
    font-weight: bold;
    color: #409EFF;
    border-bottom: 1px solid #ebeef5;
}

/* 数据容器样式 */
.data-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 15px;
    padding: 10px;
    overflow-y: auto;
    max-height: calc(100% - 40px);
}

/* 单个数据盒子样式 */
.data-box {
    border: 1px solid #ebeef5;
    border-radius: 4px;
    background-color: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    transition: all 0.3s ease;
}

.data-box:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
}

/* 数据盒子头部样式 */
.data-box-header {
    padding: 12px 15px;
    border-bottom: 1px solid #ebeef5;
    background-color: #f5f7fa;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.asin {
    font-weight: bold;
    color: #409EFF;
}

.product-name {
    color: #606266;
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 150px;
}

/* 数据盒子内容样式 */
.data-box-content {
    padding: 15px;
}

.data-field {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
}

.field-label {
    color: #909399;
    font-size: 13px;
    min-width: 70px;
    text-align: right;
    margin-right: 10px;
}

.field-value {
    color: #606266;
    font-size: 13px;
    flex: 1;
    word-break: break-all;
}

/* 销售排名区域样式 */
.rankings-container {
    margin-top: 15px;
    padding-top: 10px;
    border-top: 1px dashed #dcdfe6;
}

.rankings-header {
    font-weight: bold;
    color: #409EFF;
    margin-bottom: 5px;
}

.rankings-days {
    font-size: 12px;
    color: #909399;
    margin-bottom: 8px;
}

.rankings-values {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
}

.rank-value {
    background-color: #f5f7fa;
    padding: 3px 8px;
    border-radius: 3px;
    font-size: 12px;
    color: #606266;
}

/* 滚动条样式 */
.data-container::-webkit-scrollbar {
    width: 6px;
}

.data-container::-webkit-scrollbar-thumb {
    background-color: #c1c1c1;
    border-radius: 3px;
}

.databutton {
    width: 100%;
    padding: 10px 0;
    border-bottom: 1px solid #ebeef5;
}

::v-deep .el-date-editor .el-range-input {
    margin-left: 15px !important;
}

.databody {
    flex: 1;
    margin-top: 10px;
    width: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.datatable-container {
    flex: 1;
    display: flex;
    width: 100%;
    position: relative;
    overflow: auto;
}

.fixed-column-container {
    width: 150px;
    position: sticky;
    left: 0;
    z-index: 2;
    background-color: #f5f7fa;
    border-right: 1px solid #ebeef5;
}

.fixed-column {
    display: flex;
    flex-direction: column;
}

.fixed-header {
    padding: 12px 10px;
    font-weight: bold;
    border-bottom: 1px solid #ebeef5;
    background-color: #f5f7fa;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.scrollable-column-container {
    flex: 1;
    overflow-x: auto;
    position: relative;
}

.scrollable-columns {
    display: flex;
    flex-direction: column;
    min-width: max-content;
}

.data-row {
    display: flex;
    min-width: 100%;
    height: 40px;
    background-color: #fff;
}

.data-cell {
    flex: 1;
    min-width: 150px;
    padding: 0 10px;
    border-bottom: 1px solid #ebeef5;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
}

/* 固定列的单元格 */
.fixed-column .data-cell {
    position: sticky;
    left: 0;
    background-color: #f5f7fa;
    z-index: 1;
    justify-content: flex-start;
}

/* 滚动条样式 */
.scrollable-column-container::-webkit-scrollbar {
    height: 6px;
}

.scrollable-column-container::-webkit-scrollbar-thumb {
    background-color: #c1c1c1;
    border-radius: 3px;
}

/* 按钮样式调整 */
.databutton .el-button {
    padding: 8px 12px;
}

.databutton .el-input {
    margin-top: 5px;
}

.chart-controls {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    padding: 10px;
    background: #f5f7fa;
    border-radius: 4px;
}

.data-details {
    margin-top: 30px;

    .el-table {
        width: 100%;

        ::v-deep .el-table__row:hover {
            background-color: #f5f7fa;
        }
    }
}

.chart-container {
    display: flex;
    width: 100%;
    height: 100%;
}

.chart-loading {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    color: #409EFF;
    font-size: 16px;

    .el-icon-loading {
        font-size: 24px;
        margin-bottom: 10px;
        animation: rotating 2s linear infinite;
    }
}

@keyframes rotating {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}


#chartDom {
    width: 100%;
    height: 100%;
    min-height: 300px;
    background: #fff;
    /* 调试用背景色 */
}

.chart-placeholder {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 98%;
    height: 100%;
    color: #999;
    background-color: #f5f5f5;
    border-radius: 4px;
}

/* detaillist 区域样式 */
.detalist {
    width: 100%;
    height: 100%;
    padding: 10px;
    background: white;
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    display: flex;
    flex-direction: column;
}

.legend-header {
    padding: 8px 0;
    border-bottom: 1px solid #ebeef5;
    font-weight: bold;
    display: flex;
    justify-content: space-between;
}

.legend-header .count {
    color: #909399;
    font-weight: normal;
}

.legend-scroll-container {
    flex: 1;
    overflow-y: auto;
    margin-top: 8px;
}

.legend-item {
    display: flex;
    align-items: center;
    padding: 8px 10px;
    margin-bottom: 4px;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s;
}

.legend-item:hover {
    background-color: #f5f7fa;
}

.legend-item.active {
    background-color: #ecf5ff;
}

.color-block {
    width: 12px;
    height: 12px;
    border-radius: 2px;
    margin: 0 8px;
}

.legend-name {
    flex: 1;
    font-size: 13px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.latest-value {
    font-family: monospace;
    color: #67c23a;
    font-size: 12px;
    min-width: 40px;
    text-align: right;
}

.empty-tip {
    color: #909399;
    text-align: center;
    padding: 20px;
    font-size: 14px;
}

/* 复选框缩小 */
.legend-item .el-checkbox {
    transform: scale(0.9);
}

.el-select,
.el-input {
    width: 100%;
}

.el-button {
    width: 100%;
}

.upload-demo {
    width: 100%;
}


.management-container {
    display: flex;
    justify-content: space-between;
    gap: 20px;
}

.add-section {
    flex: 1;
    padding: 20px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    background-color: #fafafa;
    justify-content: center;
    align-items: center;
}

.list-section {
    flex: 2;
    padding: 20px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    background-color: #fafafa;
}

h3 {
    margin-top: 0;
    margin-bottom: 20px;
    color: #409EFF;
}

.bsrtask {
    width: 690px;
    height: 600px;
}

.tasklist {
    width: 100%;
    height: 90%;
    /* background-color: red; */
    border-top: 1px solid rgb(50, 133, 177);
    border-bottom: 1px solid rgb(50, 133, 177);
    margin-top: 1%;
    margin-left: 2%;
}

.bsr-task-manager {
    display: flex;
    flex-direction: column;
    height: 40vh;
}

.task-header {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
}

.task-count {
    margin-left: 15px;
    color: #666;
}

.task-list {
    flex: 1;
    overflow-y: auto;
    margin-bottom: 20px;
}

.task-item {
    margin-bottom: 15px;
}

.task-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
    font-weight: bold;
}

.file-uploader {
    display: flex;
    align-items: center;
}

.file-display {
    margin-left: 15px;
    color: #666;
    font-size: 14px;
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.task-footer {
    text-align: center;
    margin-top: 20px;
}

/* 滚动条样式 */
.task-list::-webkit-scrollbar {
    width: 6px;
}

.task-list::-webkit-scrollbar-thumb {
    background-color: #c1c1c1;
    border-radius: 3px;
}

.manage-asin-container {
    display: flex;
    justify-content: center;
    flex-direction: column;
    height: 600px;
    /* 固定总高度 */
}

.add-asin-form {
    padding: 15px;
    background: #f5f7fa;
    border-radius: 4px;
    margin-bottom: 15px;
}

.add-asin-form-inline {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 15px;
    background: #f5f7fa;
    border-radius: 4px;
    margin-bottom: 10px;
}

.asin-select-wrapper {
    flex: 7;
}

.add-asin-form-inline .el-button {
    flex: 3;
}

.dialog-footer-compact {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
}

.asin-list-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    /* 确保容器不会溢出 */
}

.table-wrapper {
    flex: 1;
    overflow-y: auto;
    /* 超过高度时显示滚动条 */
    position: relative;
}

.asin-count {
    margin-top: 10px;
    text-align: right;
    color: #909399;
    font-size: 14px;
}

/* 拖拽排序样式 */
.asin-sort-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.sort-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 12px;
    background: #f5f7fa;
    border-radius: 4px;
    margin-bottom: 8px;
    font-weight: bold;
    font-size: 13px;
}

.sort-header .asin-count {
    margin-top: 0;
    text-align: right;
}

.asin-drag-list {
    flex: 1;
    overflow-y: auto;
    min-height: 200px;
    max-height: 400px;
    padding: 5px;
}

.asin-drag-item {
    display: flex;
    align-items: center;
    padding: 8px 12px;
    margin-bottom: 6px;
    background: #fff;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    transition: all 0.3s;
}

.asin-drag-item:hover {
    border-color: #409eff;
    box-shadow: 0 2px 8px rgba(64, 158, 255, 0.2);
}

.drag-handle {
    cursor: move;
    padding: 5px 8px;
    color: #909399;
    font-size: 14px;
    margin-right: 8px;
}

.drag-handle:hover {
    color: #409eff;
}

.asin-info {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 10px;
}

.asin-position {
    min-width: 60px;
    text-align: center;
}

.asin-details {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    min-width: 0;
}

.asin-text {
    font-weight: bold;
    color: #303133;
    font-family: monospace;
    font-size: 12px;
}

.pm-text {
    color: #606266;
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
}

.asin-actions {
    margin-left: 8px;
    flex-shrink: 0;
}

.empty-tip {
    text-align: center;
    padding: 40px;
    color: #909399;
    font-size: 14px;
}

.dialog-footer {
    text-align: right;
}

/* 表格滚动条样式 */
.table-wrapper::-webkit-scrollbar {
    width: 6px;
    height: 6px;
}

.table-wrapper::-webkit-scrollbar-thumb {
    background-color: #c1c1c1;
    border-radius: 3px;
}

.table-wrapper::-webkit-scrollbar-track {
    background-color: #f5f5f5;
}

/* 拖放相关样式 */
.legend-item.draggable-item {
    position: relative;
}

.legend-item.draggable-item:hover {
    background-color: #e6f7ff;
}

.drag-handle {
    margin-left: auto;
    color: #c0c4cc;
    transition: color 0.2s;
}

.legend-item.draggable-item:hover .drag-handle {
    color: #409eff;
}

/* 图像生成器容器 */
.chart-generator-container {
    margin-top: 15px;
    padding-top: 15px;
    border-top: 2px dashed #dcdfe6;
}

.chart-generator-header {
    padding: 8px 0;
    font-weight: bold;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.chart-generator-dropzone {
    min-height: 100px;
    border: 2px dashed #dcdfe6;
    border-radius: 4px;
    padding: 10px;
    background-color: #fafafa;
    transition: all 0.3s;
    margin-top: 8px;
}

.chart-generator-dropzone:hover {
    border-color: #409eff;
    background-color: #ecf5ff;
}

.chart-generator-dropzone.has-items {
    border-style: solid;
    border-color: #e4e7ed;
    background-color: #ffffff;
}

.drop-placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    min-height: 80px;
    color: #909399;
}

.drop-placeholder i {
    font-size: 32px;
    margin-bottom: 8px;
    color: #c0c4cc;
}

.drop-placeholder span {
    font-size: 14px;
}

.selected-asin-item {
    display: flex;
    align-items: center;
    padding: 8px 10px;
    margin-bottom: 6px;
    background-color: #f5f7fa;
    border-radius: 4px;
    transition: all 0.2s;
}

.selected-asin-item:hover {
    background-color: #e6f7ff;
}

.selected-asin-item .color-block {
    width: 12px;
    height: 12px;
    border-radius: 2px;
    margin-right: 8px;
}

.selected-asin-item .asin-name {
    flex: 1;
    font-size: 13px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.selected-asin-item .remove-btn {
    cursor: pointer;
    color: #c0c4cc;
    transition: color 0.2s;
}

.selected-asin-item .remove-btn:hover {
    color: #f56c6c;
}

.chart-generator-actions {
    display: flex;
    gap: 8px;
    margin-top: 10px;
}

.chart-generator-actions .el-button {
    flex: 1;
}
</style>